import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Reveal } from '../components/Reveal';
import { EndNote } from '../components/EndNote';
import { SeoHead } from '../components/SeoHead';
import { projects } from '../data/projects';
import { ProjectGrid } from '../components/ProjectGrid';
export function Work() {
  const [searchParams, setSearchParams] = useSearchParams();
  const disciplines = useMemo(() => ['All', ...Array.from(new Set(projects.map(p => p.discipline)))], []);
  const requested = searchParams.get('category');
  const filter = requested && disciplines.includes(requested) ? requested : 'All';
  function setFilter(next: string) {
    if (next === 'All') {
      setSearchParams({});
    } else {
      setSearchParams({
        category: next
      });
    }
  }
  const visible = useMemo(() => filter === 'All' ? projects : projects.filter(project => project.discipline === filter), [filter]);
  return <div data-id="element-289" data-mp="3i9bwftotxisy">
      <SeoHead title="Work — Mobile Pop-Ups, Activations & Tradeshow Booths | Breezy Experiential" description="Selected experiential work by Breezy Experiential: mobile retail pop-ups, national sampling tours, influencer events, brand activations and tradeshow booths for Netflix, Hydrafacial, ZO Skin Health, TONYMOLY and more." data-id="element-290" data-mp="3i8tucgfhkad4" />

      <header className="mx-auto max-w-page px-6 pb-8 pt-14 md:px-10 md:pb-12 md:pt-24" data-id="element-291" data-mp="3n6lm9ag4rwhb">
        <h1 className="font-display text-4xl font-bold uppercase leading-[0.9] md:text-7xl" data-id="element-292" data-mp="5qdk1v4xb3w8">
          The <span className="text-lilac" data-id="element-293" data-mp="su5sv886r4a">Work</span>
        </h1>
        <p className="mt-6 max-w-md text-sm leading-relaxed text-muted" data-id="element-294" data-mp="ertshxc6gvxt">
          Pop-ups, national tours, conferences and tradeshows — built, trucked and run by us.
        </p>
      </header>

      <div className="mx-auto max-w-page px-6 pb-12 md:px-10 md:pb-16" data-id="element-295" data-mp="2gjgcvg1kdslb">
        <div role="group" aria-label="Filter projects by discipline" className="flex flex-wrap items-center gap-x-6 gap-y-2 border-b border-line pb-5" data-id="element-296" data-mp="2bl6ih7nnyw0r">
          {disciplines.map(discipline => {
          const active = discipline === filter;
          return <button key={discipline} type="button" onClick={() => setFilter(discipline)} aria-pressed={active} className={`text-[0.65rem] uppercase tracking-micro transition-colors ${active ? 'text-lilac' : 'text-muted hover:text-cream'}`} data-id="element-297" data-mp="pfoj7g6v63sn">
                {discipline}
              </button>;
        })}
          <span className="ml-auto text-[0.65rem] uppercase tracking-micro text-muted" data-id="element-298" data-mp="187hbf8e3zkzb">
            {visible.length}
          </span>
        </div>

        {visible.length === 0 ? <p className="mt-16 font-display text-xl uppercase text-muted" data-id="element-299" data-mp="1h8ouwkbyuh9c">
            Nothing in this category yet.
          </p> : <div className="mt-10 grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-300" data-mp="36ohqweeln6ob">
            {visible.map((project, index) => <Reveal key={project.slug} delay={index % 3 * 0.05} data-id="element-301" data-mp="31p52hp82xrjm" data-mpi={index}>
                <Link to={`/work/${project.slug}`} className="group block" data-id="element-302" data-mp="2xnjlbroiir3m">
                  <div className="overflow-hidden bg-cream/5" data-id="element-303" data-mp="2xpxhk3uxi9cr">
                    {project.video ? <video src={project.video} poster={project.image || undefined} autoPlay loop muted playsInline aria-label={`${project.title} for ${project.client}`} className="h-56 w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.03] md:h-64" data-id="element-304" data-mp="2sr2zj44scotp" /> : <img src={project.image} alt={`${project.title} for ${project.client}`} className="h-56 w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.03] md:h-64" data-id="element-305" data-mp="86c54phvj2pf" />}
                  </div>
                  <div className="mt-3 flex items-baseline justify-between gap-4" data-id="element-306" data-mp="3exwyuhofza2e">
                    <h2 className="font-display text-lg uppercase leading-none transition-colors group-hover:text-lilac md:text-xl" data-id="element-307" data-mp="3jvp2g8yg8kmf">
                      {project.title}
                    </h2>
                    <span className="shrink-0 text-[0.6rem] uppercase tracking-micro text-muted" data-id="element-308" data-mp="ffnpfsenmp3v">
                      {project.year}
                    </span>
                  </div>
                  <p className="mt-1.5 text-[0.65rem] uppercase tracking-micro text-muted" data-id="element-309" data-mp="6nlpdv8hzau4">
                    {project.client} — {project.discipline}
                  </p>
                </Link>
              </Reveal>)}
          </div>}
      </div>

      <EndNote data-id="element-310" data-mp="18ji0t85ihp0a" />
    </div>;
}